// src/components/Hero.jsx
import React, { useState, useEffect, useRef } from 'react';
import '../styles/Hero.css';

import img1 from '../Assets/Images/akij-house.jpg';
import img2 from '../Assets/Images/akij-textile-mills-ltd.jpg';
import img3 from '../Assets/Images/akij-bakers-ltd.jpg';
import img4 from '../Assets/Images/akij-flour-mills-ltd.jpg';
import img5 from '../Assets/Images/akij-printing-and-packages-ltd.jpg';
import img6 from '../Assets/Images/Lighthouse-International-School.jpg';
import img7 from '../Assets/Images/akij-foundation-school-and-college.jpg';
import img8 from '../Assets/Images/Monowara-Active-Technical-Institute.jpg';

const slides = [
  {
    img: img1,
    title: "Akij House",
    subtitle: "Crafting Premium Living Spaces",
    link: "https://www.akij.net/"
  },
  {
    img: img2,
    title: "Akij Textile Mills Ltd.",
    subtitle: "Weaving Quality with Innovation",
    link: "https://www.akijtextile.com/"
  },
  {
    img: img3,
    title: "Akij Bakers Ltd.",
    subtitle: "Delighting Taste Buds Everyday",
    link: "https://akijbakers.net/"
  },
  {
    img: img4,
    title: "Akij Flour Mills Ltd.",
    subtitle: "Pure Grains, Pure Goodness",
    link: "https://www.akijflour.com/"
  },
  {
    img: img5,
    title: "Akij Printing & Packages Ltd.",
    subtitle: "Printing the Future, Today",
    link: "https://www.akijhouse.com/"
  },
  // {
  //   img: img6,
  //   title: "Lighthouse International School",
  //   subtitle: "Building dreams and sharing laughs with every scoop of sand",
  //   link: "https://lighthouseschoolbd.com/"
  // },
  {
    img: img7,
    title: "Akij Foundation School & College",
    subtitle: "Building dreams and sharing laughs with every scoop of sand",
    link: "https://afsc.edu.bd/"
  },
  // {
  //   img: img8,
  //   title: "Monowara Active Technical Institute",
  //   subtitle: "Building dreams and sharing laughs with every scoop of sand",
  //   link: "https://www.mati.edu.bd/"
  // },
];

function Hero() {
  const [current, setCurrent] = useState(0);
  const slidesLength = useRef(slides.length);

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrent(prev => (prev + 1) % slidesLength.current);
    }, 5000);
    return () => clearInterval(interval);
  }, []);

  const goToNext = () => setCurrent((current + 1) % slidesLength.current);
  const goToPrev = () => setCurrent((current - 1 + slidesLength.current) % slidesLength.current);

  return (
    <section className="hero-section">
      <div className="slider-wrapper">
        {slides.map((slide, index) => (
          <div
            key={index}
            className={`slide ${index === current ? 'active' : ''}`}
            style={{ backgroundImage: `url(${slide.img})` }}
          >
            <div className="hero-overlay">
              <div className="hero-content">
                <h1 className="hero-title">{slide.title}</h1>
                <p className="hero-subtitle">{slide.subtitle}</p>
                <a href={slide.link} className="hero-button" target="_blank" rel="noopener noreferrer">Learn More</a>
              </div>
            </div>
          </div>
        ))}

        {/* <button className="prev-btn" onClick={goToPrev}>&#10094;</button> */}
        {/* <button className="next-btn" onClick={goToNext}>&#10095;</button> */}
        <div className="hero-nav-buttons">
          <button onClick={goToPrev}>&larr;</button>
          <button onClick={goToNext}>&rarr;</button>
        </div>

      </div>
    </section>
  );
}

export default Hero;
